import { sleep } from '../../../util/sleep';
import { checkForSpreadsheetMimeType } from '../../utils/checkForSpreadsheetMimeType';

interface ImportWorkspaceQuizBySpreadsheetParams {
  workspaceId: string;
  parentId: string;
  file: File;
}

export function importQuizToWorkspaceBySpreadsheet(
  onUploadProgress: (progressEvent: any) => void
) {
  return async ({
    parentId,
    workspaceId,
    file,
  }: ImportWorkspaceQuizBySpreadsheetParams) => {
    const { type } = file;
    checkForSpreadsheetMimeType(type);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('workspaceId', workspaceId);
    await sleep(500);
    onUploadProgress(10);
    await sleep(500);
    onUploadProgress(20);
    await sleep(500);
    onUploadProgress(40);
    await sleep(500);
    onUploadProgress(50);
    await sleep(500);
    onUploadProgress(100);

    console.error(
      `Posting ${file.name} to workspacesId: ${workspaceId} in folder ${parentId}`
    ); // TODO ADD API CALL HERE!

    return { workspaceId };
  };
}
